export enum CardsFeedLayouts {
  CAROUSEL = 'CAROUSEL',
  GRID = 'GRID',
}
